import RateCalculator from '../etc/RateCalculator/RateCalculatorAlone';
import RepaymentInfoBottomSheet from '../feedback/RepaymentInfoBottomSheet/RepaymentInfoBottomSheet';
import useRepaymentInfoBottomSheet from '../../application/hooks/useRepaymentInfoBottomSheet';
import RateCalculatorAlone from '../etc/RateCalculator/RateCalculatorAlone';

const RateCalcAlone = () => {
  const {
    openInfoBottomSheet,
    handleClickOpenInfoBottom,
    handleClickCloseInfoBottom,
  } = useRepaymentInfoBottomSheet();
  return (
    <>
      <RateCalculatorAlone
        isBottomSheet={false}
        onInfoIconClick={handleClickOpenInfoBottom}
      />
      <RepaymentInfoBottomSheet
        isShow={openInfoBottomSheet}
        handleClickCloseInfoBottom={handleClickCloseInfoBottom}
        isBottomSheet={true}
      />
    </>
  );
};

export default RateCalcAlone;
